'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('vendor-edit', {
      url: '/vendor/edit/:id',
      template: '<vendor-edit></vendor-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/vendor-edit/vendor-edit.routes.js